'use client';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { forwardRef, useEffect, useRef, useState } from 'react';
import { PhoneInput } from 'react-international-phone';
import './phone-input-styles.css';
import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

export const PhoneInputField = forwardRef(({ className, ...props }: any, ref) => {
  const [focused, setFocused] = useState(false);
  const phoneInputRef = useRef(null);

  const locale = useLocaleStore(s => s.currentLocale);

  useEffect(() => {
    const handleClickOutside = (event: any) => {
      const current = phoneInputRef.current as any;

      if (current && !current.contains(event.target)) {
        setFocused(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [phoneInputRef]);

  return (
    <div
      ref={phoneInputRef}
      className={cn(
        'rounded-lg border border-border bg-white',
        focused ? 'outline outline-1 outline-primary' : 'outline-none',
      )}
    >
      <PhoneInput
        defaultCountry={locale}
        name="phone"
        onFocus={() => setFocused(true)}
        onBlur={() => setFocused(false)}
        inputClassName={cn('bg-white')}
        inputStyle={{
          backgroundColor: 'bg-white !important',
          height: '48px !important',
          paddingLeft: '20px',
          width: '100%',
          borderEndEndRadius: 'var(--radius)',
          borderStartEndRadius: 'var(--radius)',
          border: 'none',
        }}
        countrySelectorStyleProps={{
          buttonClassName: 'bg-white',
          buttonStyle: {
            height: '48px !important',
            backgroundColor: 'bg-white !important',
            borderStartStartRadius: 'var(--radius)',
            borderEndStartRadius: 'var(--radius)',
            paddingLeft: '12px',
            border: 'none',
          },
        }}
        {...props}
      />
    </div>
  );
});

PhoneInputField.displayName = 'PhoneInputField';
